import { Link } from "react-router-dom";
import {ru} from '../data/ru'
import {by} from '../data/by'
import {useContext, useEffect, useState} from "react";
import API from "../API";
import Edit from "./Edit";
import Modal from "./Modal";
// import edit2 from '../../img/edit2.png';
import { componentOpenEdit } from "./utils";
import {BASE_URL, FILE_URL} from "../../config";
import Context from "../context";
import Loader from "../layouts/Loader";

export default function ProfileHeader({organization, elements, additionals}) {
    const type = localStorage.getItem('type')
    const {isLoading,setIsLoading } = useContext(Context)

    const language = localStorage.getItem('lang') === 'ru' ? ru.RoleIdOne : by.RoleIdOne;
    const [user, setUser] = useState({});
    const [name, setName] = useState('')
    const [isEdit, setIsEdit] = useState(true)
    const api = new API()

    useEffect(() => {
        setIsLoading(true)
        api.getUser(localStorage.getItem('id'))
            .then((result) => {
                setUser(result)
                setName(result.name)
                setIsLoading(false)
            })
    }, [])
    const editUser = (newName) => {
        setName(newName);
    }
    if(isLoading){
        return <Loader/>
    }
    return (
        <>
            <div className='profile_block_fio'>
                {/* <div className='admin_flex'> */}
                <div className='profile_fio_edit' style={{position: 'relative'}}>
                    <h2 className='profile_fio'>{name}</h2>
                    {/* Вопросы на счет сетизэдит */}
                    {type !== 'Student' ? <Modal additional={{
                        id: localStorage.getItem('id'),
                        name: name,
                        setIsEdit: setIsEdit,
                        type: 'user',
                        editUser: editUser
                    }} componentOpen={componentOpenEdit} component={Edit} setIsEdit={setIsEdit}/> : null}
                    {user.nameOrganization ? <p className="profile_organization">{user.nameOrganization}</p> : null}
                </div>
                <div className='profile_flex_buttons'>
                    {type === 'Admin' || type === 'Teacher' || type === 'Curator' ?
                        <Link to='/statistics'>
                            <button className='profile_block_fio-button'>{language.buttonStatistics}</button>
                        </Link> : null
                    }
                    {/*руководства*/}
                    {type === 'Expert' &&
                    <button className='profile_block_fio-button'
                            onClick={e => window.open(BASE_URL + FILE_URL + '/expert')}>Инструкция</button>
                    }
                    {type === 'SuperExpert' &&
                    <button className='profile_block_fio-button'
                            onClick={e => window.open(BASE_URL + FILE_URL + '/expert')}>Инструкция</button>
                    }
                    {type === 'Student' &&
                    <button className='profile_block_fio-button'
                            onClick={e =>window.open(BASE_URL + FILE_URL + '/student')}>Инструкция</button>
                    }
                    {type === 'Curator' &&
                    <button className='profile_block_fio-button'
                            onClick={e =>window.open(BASE_URL + FILE_URL + '/curator')}>Инструкция</button>
                    }
                    {type === 'Teacher' &&
                    <button className='profile_block_fio-button'
                            onClick={e =>window.open(BASE_URL + FILE_URL + '/teacher')}>Инструкция</button>
                    }
                    {elements}

                </div>
            </div>
            <div className="admin_additional-settings">{additionals}</div>
        </>
    )
}